import { accountBloc } from "@fl-purchase/core/account";
import Cookies from "js-cookie";
import { datasource } from "react-flowder";
import { mergeMap, throwError, of, tap } from "rxjs";

import { AuthorizationError } from "~/shared/errors";
import { noop } from "~/shared/noop";

const { stream, ...command } = accountBloc;

/**
 * @package
 */
export const authorizedStream = stream().pipe(
  mergeMap((auth) => {
    return auth ? of(auth) : throwError(() => new AuthorizationError());
  }),
  tap(async () => {
    await accountBloc.getToken(true).match((token) => {
      Cookies.set("__session", token);
    }, noop);
  }),
);

export const accountQuery = datasource(stream);

export const authorizedQuery = datasource(() => authorizedStream);
export const accountCommand = command;

export type AccountQuery = typeof accountQuery;
export type AuthorizedQuery = typeof authorizedQuery;
export type AccountCommand = typeof accountCommand;
